import {HttpUtils} from "@/api/common/HttpUtils";

export class DoNotSellListService {

    constructor(auth){

        this._auth = auth;

        if (this._auth == null){
            throw new Error("[e694733] Auth token is undefined");
        }


        this._baseUrl = `${process.env.VUE_APP_API_URL}/v1/catalog/donotsell`;
        this._headers = HttpUtils.getHttpHeaders(this._auth, 'text/json');

    }

    getList(){

        return new Promise((resolve, reject) => {
            try {
                let url = `${this._baseUrl}`;

                HttpUtils.get(url, this._auth).then(data => {
                    if (data == null) {
                        window.tracer.debug(`[d925021] 0 DoNotSell parts returned`);
                        resolve([]);
                    } else {
                        window.tracer.debug(`[d200103] ${data.length} DoNotSell parts returned`);
                        resolve(data);
                    }
                }).catch(e => {

                    window.tracer.error("[e595754] Error getting the list of DoNotSell parts from the server.")
                    if (e != null) {
                        window.tracer.error(e);
                    }
                    reject(e);
                });
            }
            catch(e) {

                window.tracer.error("[e894740] Error getting the DoNotSell");
                window.tracer.error(e);

                reject(e);
            }

        });

    }

    saveItem(partNumber){

        return new Promise((resolve, reject) => {
            try{

                if (partNumber == null || partNumber.length === 0){
                    window.tracer.warn("[e542199] partNumber argument cannot be empty or undefined");
                    let err = new Error("[e433169] partNumber argument cannot be empty or undefined");
                    reject(err);
                }

                let data = {
                    partNumber: partNumber
                }

                let url = `${this._baseUrl}`;
                HttpUtils.post(url, this._auth, data).then(data => {

                    if (data == null){

                        let err404 = new Error("[e782842] Unable to reach endpoint. Possible 404 error");
                        reject(err404)
                        return;
                    }

                    if (data){
                        resolve();
                    }
                    else{

                        let errFail = new Error("[e525826] Endpoint returned unexpected 'false' value. Item not saved.");
                        reject(errFail)
                    }

                }).catch(e => {
                    window.tracer.error("[e646144] Error saving the part number in the server.");
                    if (e != null) {
                        window.tracer.error(e);
                    }
                    reject(e);
                });
            }
            catch(e){

                window.tracer.error("[e907170] Error saving part number.")
                window.tracer.error(e);
                reject(e);
            }

        });

    }

    deleteItem(partNumber){

        return new Promise((resolve, reject) => {
            try {

                if (partNumber == null || partNumber.length === 0) {
                    window.tracer.warn("[e228847] partNumber argument cannot be empty or undefined");
                    let err = new Error("[e440805] partNumber argument cannot be empty or undefined");
                    reject(err);

                    return;
                }

                let url = `${this._baseUrl}/${partNumber}`;
                HttpUtils.delete(url, this._auth).then(data => {

                    if (data == null){

                        let err404 = new Error("[e576799] Unable to reach endpoint. Possible 404 error");
                        reject(err404)
                        return;
                    }

                    if (data){
                        resolve();
                    }
                    else{

                        let errFail = new Error("[e515489] Endpoint returned unexpected 'false' value. Item not deleted.");
                        reject(errFail)
                    }

                }).catch(e => {
                    window.tracer.error("[e672882] Error deleting the part number in the server.");
                    if (e != null) {
                        window.tracer.error(e);
                    }
                    reject(e);
                });
            }
            catch(e){

                window.tracer.error("[e233580] Error deleting part number.")
                window.tracer.error(e);
                reject(e);
            }

        });
    }
}